import { api } from "./api";

export const GetMessageTemplate = async (addUrl = '') =>{
    let url = `/message/messages/list/get?${addUrl}`
    return await api.get(url)
}

export const UpateStatus = async (paylod) =>{
    return await api.post('message/messages/status/update',paylod)
}

// export const StudentAttendence = async (paylod)=>{
//     return await api.post(`/message/send_admit_attendance_message`,paylod)
export const StudentAttendence = async (addUrl = '')=>{
    let url = `message/send_admit_attendance_message?${addUrl}`
    return await api.get(url)
}
export const StudentAttendenceAbsent = async (addUrl = '')=>{
    let url = `message/SendAdmitAbsentMessage?${addUrl}`
    return await api.get(url)
}

export const getAllContacts = async (addUrl = '')=>{
    let url = `/message/all/contacts?${addUrl}`
    return await api.get(url)
}

export const historyDataSoftware = async (addUrl = '') => {
    let url = `/message/failed/whatsapp`;
    return api.get(url)
};

export const messageResend = async (data) => {
    return api.get(`message/failed/messages/rey/send`,data)
}